import { Store, Module, ActionContext } from 'vuex'
import Ajax from '../../lib/ajax'
import ListModule from './list-module'
import PageResult from '@/store/entities/page-result';
import BackFlowList from '../entities/back-flow-list'
import ListState from './list-state'

interface BackFlowListState extends ListState<BackFlowList> {
     FlowInfo: BackFlowList,
}

class BackFlows extends ListModule<BackFlowListState, any, BackFlowList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackFlowList>(),
        loading: false,
        logisticsInfo: BackFlowList,


    }
    actions = {
        async getAll(context: ActionContext<BackFlowListState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Flow/GetFlowList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackFlowList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExcelFlow', { params: payload.data, responseType: "blob", timeout: 100000 }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '用户流水.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        },
    };
    mutations = {
        setCurrentPage(state: BackFlowListState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackFlowListState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const backflows = new BackFlows();
export default backflows;